import React, { PropTypes } from 'react';
import { FormattedTime, FormattedMessage } from 'react-intl';

const propTypes = {
  activeDay: PropTypes.number,
  title: PropTypes.string.isRequired,
  start: PropTypes.string.isRequired,
  end: PropTypes.string,
};

const Event = (props) => {
  const starting = new Date(`October ${props.activeDay}, 2017, ${props.start}`);
  const ending = new Date(`October ${props.activeDay}, 2017, ${props.end}`);
  const time = !props.end
  ? (
    <FormattedTime
      value={starting}
    />
  )
  : (
    <FormattedMessage
      id="time"
      description="Event and time"
      defaultMessage="{starting, time, short} - {ending, time, short}"
      values={{
        icon: <i className="calendar icon" />,
        starting,
        ending,
      }}
    />
  );

  const result = (
    <tr>
      <td className="collapsing">{props.title}</td>
      <td>{time}</td>
    </tr>
  );

  return result;
};

Event.propTypes = propTypes;

export default Event;



/** WEBPACK FOOTER **
 ** ./src/components/screens/generalProgramming/Event.js
 **/